import { OrderWithEvents } from '../../types/orders';
import fulfill from '../../fulfill';
import { SideEffectFunction } from '../../sideEffects';
import {
    ActionTypes,
    GetOrder,
    OrderResponse,
    OrderNotFoundResponse,
    CreateComment,
    CreateCommentResponse,
    DeleteComment,
    DeleteCommentResponse
} from './actions';
import { CORE_API_HOSTNAME } from '../../env';

type FetchOrderResult = OrderResponse | OrderNotFoundResponse;

const fetchOrder: SideEffectFunction<GetOrder, FetchOrderResult> = async (action) => {
    const result: FetchOrderResult = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/shopping/orders/${action.payload.orderId}?include_events=true`,
        handlers: {
            200: (order: OrderWithEvents) => ({
                type: ActionTypes.OrderResponse,
                payload: {
                    order,
                },
                meta: {
                    cause: action,
                },
            }),
            404: () => ({
                type: ActionTypes.OrderNotFoundResponse,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const createComment: SideEffectFunction<CreateComment, CreateCommentResponse> = async (action) => {
    const result: CreateCommentResponse = await fulfill.post({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/shopping/orders/${action.payload.orderId}/comments?include_events=true`,
        json: action.payload.requestBody,
        handlers: {
            200: (order: OrderWithEvents) => ({
                type: ActionTypes.CreateCommentResponse,
                payload: {
                    order,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const deleteComment: SideEffectFunction<DeleteComment, DeleteCommentResponse> = async (action) => {
    const result: DeleteCommentResponse = await fulfill.delete({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/shopping/orders/${action.payload.orderId}/comments/${action.payload.commentId}?include_events=true`,
        handlers: {
            200: (order: OrderWithEvents) => ({
                type: ActionTypes.DeleteCommentResponse,
                payload: {
                    order,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.GetOrder]: fetchOrder,
    [ActionTypes.CreateComment]: createComment,
    [ActionTypes.DeleteComment]: deleteComment,
};

export default effects;
